export const educationData = [
    {
        id: 1,
        institution: 'Microverse',
        course: 'Full-stack development program',
        startYear: 'May 2022',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Modern University for Technology & Information - MTI',
        course: 'Business Administration and Management',
        startYear: '2016',
        endYear: '2020'
    },
]